import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaBolt } from "react-icons/fa";

const EVENT_LABELS = {
  "user.signup": "User Signup",
  "user.trial_started": "Trial Started",
  "user.trial_expiring": "Trial Expiring",
  "user.subscription_expired": "Subscription Expired",
  "user.plan_upgraded": "Plan Upgraded",
  "user.plan_downgraded": "Plan Downgraded",
  "session.disconnected_persistent": "WhatsApp Disconnected",
  "user.inactive": "User Inactive",
  "user.low_message_quota": "Low Message Quota",
  "user.payment_failed": "Payment Failed",
};

export default function EventTriggerNode({ data, selected }) {
  return (
    <div className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[220px] transition-shadow ${selected ? "border-emerald-500 shadow-md" : "border-surface-border"}`}>
      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px]" style={{ background: "linear-gradient(135deg, #059669, #10b981)" }}>
        <FaBolt size={10} className="text-white" />
        <span className="text-xs font-semibold text-white">Event Trigger</span>
      </div>
      <div className="px-3 py-2.5">
        {data.event ? (
          <p className="text-xs text-ink-primary font-medium">{EVENT_LABELS[data.event] || data.event}</p>
        ) : (
          <p className="text-xs text-ink-muted italic">Select an event...</p>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} className="!w-3 !h-3 !bg-emerald-500 !border-2 !border-white" />
    </div>
  );
}
